import { render, staticRenderFns } from "./Fora.vue?vue&type=template&id=72ee836e"
import script from "./Fora.vue?vue&type=script&lang=js"
export * from "./Fora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports